import { Dispatch } from 'redux'
import { Logger } from 'DVWebNodeUtils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import {
  triggerPurchasingTransition,
  resetPurchasingTransition,
  failedPurchasingDueToClientDependency
} from '../actionBox'
import { startPurchase, PurchaseError } from '../../integrations/purchase'
import { refreshMainActionBox, refreshBtfActionBoxes, refreshEpisode } from '../wps'
import { safeBoolean } from '../../utils/utils'
import { store } from '../../store'
import { whisperCacheDataSelector } from '../../selectors/player'
import { Player, PrepareConfig } from '../../integrations/playerIntegrationAui'
import { PType } from '../../integrations/aui'

const COUNTER_PARALLEL_PURCHASES = 'DVWebNodeDetail-ParallelAuiPurchases'
let parallelPurchases = 0

declare let window: Window & { P: PType }

export type RefreshAfterPurchase = {
  pageTitleId: string,
  offerAsin: string,
  canonicalTitleId?: string,
  isSeasonPurchase: boolean
}
export const refreshAfterPurchaseActionDispatcher = async ({ pageTitleId, offerAsin, canonicalTitleId, isSeasonPurchase }: RefreshAfterPurchase) => {
  const promises = []
  promises.push(refreshMainActionBox(pageTitleId, offerAsin, canonicalTitleId ))
  if (safeBoolean(isSeasonPurchase)) {
    promises.push(refreshBtfActionBoxes(pageTitleId))
  } else if (canonicalTitleId) {
    promises.push(refreshEpisode(canonicalTitleId))
  }

  await Promise.all(promises);

  // Re-prepare player after purchase to update whisper cache
  const state = store.getState()
  const useNodePlayer = state.features.usePlayer

  if (!useNodePlayer) {
    const whisperCacheData = whisperCacheDataSelector(state)

    if (typeof window !== 'undefined' && typeof window.P !== 'undefined') {
      window.P.when('dv-player-integration').execute((auiPlayer: Player) => {
        auiPlayer &&
          whisperCacheData &&
          auiPlayer.prepare({
            ...whisperCacheData,
            useFullView: true
          } as PrepareConfig)
      })
    }
  }
}


// TODO look if we could reduce number of params to this action creator
// we should probably only have offerAsin, the rest being retrieved directly from the store via selectors
// AVWebDetailPage-3129

export const triggerAuiPurchase = (dispatch: Dispatch) => async (
  logger: Logger,
  pageTitleId: string,
  canonicalTitleId: string | undefined,
  tvodAction: WpsRuntime.atv.wps.PurchaseActionProps,
  refTag: string,
  dataAttrs: object
) => {
  const { asin: offerAsin, purchaseData, csrfToken, offerToken } = tvodAction
  const purchasingTransitionArgs = {
    canonicalTitleId,
    offerAsin,
    isSeasonPurchase: purchaseData.isSeasonPurchase,
    purchasingText: purchaseData.text || '',
    errorHeader: purchaseData.modalText || '',
  }

  const purchaseOptions = {
    ...purchaseData,
    ...dataAttrs,
    asin: offerAsin,
    pinVerification: { csrfToken },
    purchaseArgs: {
      refTag,
      offerToken,
      csrfToken,
      asin: offerAsin
    }
  }

  const refreshAfterPurchaseArgs = {
    canonicalTitleId,
    pageTitleId,
    offerAsin,
    isSeasonPurchase: purchaseData.isSeasonPurchase,
  }

  parallelPurchases += 1
  logger.count(COUNTER_PARALLEL_PURCHASES, parallelPurchases, false)
  dispatch(triggerPurchasingTransition(purchasingTransitionArgs))
  startPurchase({ logger, options: purchaseOptions })
    .then(args => {
      parallelPurchases -= 1
      if (args && args.reload === false) {
        dispatch(
          resetPurchasingTransition({
            offerAsin,
            canonicalTitleId
          })
        )
      } else {
        refreshAfterPurchaseActionDispatcher(refreshAfterPurchaseArgs)
      }
    })
    .catch(err => {
      logger.error(err)
      parallelPurchases -= 1
      if (err && err.reason === PurchaseError.AUI_DEPENDENCY) {
        dispatch(
          failedPurchasingDueToClientDependency({
            offerAsin,
            canonicalTitleId
          })
        )
      }
    })
}
